// @flow
import React, {Component} from 'react';
import FilterGroup from '../FilterGroup/FilterGroup';
import {FilterGroupExpandable} from '../FilterGroupExpandable/FilterGroupExpandable';
import {displayFilterGroup, filterGroupFilters} from '../../utils/filters';
import Experiment from '@homeaway/react-experiment';
import {HA_FAB_FILTER_POPULAR_GROUP} from '../../abacus/experiments';

import './MoreFilters.less';
import type {Node} from 'react';
import type {Refinement, RefinementTooltip} from '../FilterGroup/FilterGroup';

/* istanbul ignore next */
export type FilterGroupType = {
    name: string,
    key: string,
    filters: Refinement[]
};

export type Props = {
    filterGroups: FilterGroupType[],
    handleChecked: (event: SyntheticEvent<HTMLInputElement>) => void,
    numLines?: number,
    checked: string[],
    className?: string,
    tooltipOptions: RefinementTooltip
};

const anyChecked = (filters: Refinement[], checked: string[]): boolean => {
    for (let i = 0; i < filters.length; i++) {
        if (checked.includes(filters[i].key)) {
            return true;
        }
    }
    return false;
};

type State = {
    filterChecked: string[]
};

export const renderFilterGroups = (
    filterChecked: string[],
    {
        filterGroups,
        className,
        handleChecked,
        checked,
        numLines = 6,
        tooltipOptions
    }: Props
): Node[] => {
    return filterGroups.map((filterGroup) => {
        const groupFilters = filterGroupFilters(filterGroup);
        const filterGroupId = filterGroup.key;
        return (
            <div
                className={className}
                key={filterGroupId}
                data-wdio={`MoreFilterGroup_${filterGroupId}`}
                role="menuitem"
            >
                {displayFilterGroup(filterGroup) &&
                    groupFilters.length > numLines && (
                        <div
                            className="MoreFilters__filterGroup"
                            data-wdio={`MoreorLess_${filterGroupId}`}
                        >
                            <FilterGroupExpandable
                                handleChecked={handleChecked}
                                groupName={filterGroup.name}
                                filters={groupFilters}
                                checked={checked}
                                filterGroupId={filterGroupId}
                                expanded={anyChecked(
                                    groupFilters,
                                    filterChecked
                                )}
                                tooltipOptions={tooltipOptions}
                            />
                        </div>
                    )}
                {displayFilterGroup(filterGroup) &&
                    groupFilters.length <= numLines && (
                        <div className="MoreFilters__filterGroup">
                            <FilterGroup
                                handleChecked={handleChecked}
                                groupName={filterGroup.name}
                                filterGroupId={filterGroupId}
                                filters={groupFilters}
                                checked={checked}
                                tooltipOptions={tooltipOptions}
                            />
                        </div>
                    )}
            </div>
        );
    });
};

export class MoreFilters extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            filterChecked: this.props.checked // we only want to set this at initial mount
        };
    }

    render() {
        const {filterChecked} = this.state;
        return renderFilterGroups(filterChecked, this.props);
    }
}

const InstrumentedMoreFilters = (props: Props) => {
    return (
        <Experiment name={HA_FAB_FILTER_POPULAR_GROUP}>
            {() => <MoreFilters {...props} />}
        </Experiment>
    );
};

export default InstrumentedMoreFilters;
